import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-reload"
export default class extends Controller {
  static targets = ['value'];
  static values = {
    param: String
  }

  change() {
    if (this.hasParamValue) {
      let idValue = this.valueTarget.options[this.valueTarget.selectedIndex].value;
      let queryParams = new URLSearchParams(window.location.search);
      queryParams.set(this.paramValue, idValue);
      window.location.href = window.location.href.split('?')[0] + "?" + queryParams.toString();
    }

  }
}
